export default __webpack_public_path__ + "static/test_3_1-e0129cb7cdb9bbed7a30c04a92588fec.png";